<template>
  <Component
    :is="currentDialog.component"
    v-if="currentDialog"
    v-bind="currentDialog.props"
    @close-dialog="dialog.popDialog()"
  ></Component>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { useDialogStore } from "../store/dialog";

const dialog = useDialogStore();
const currentDialog = computed(() => dialog.currentDialog);
</script>
